import { render, staticRenderFns } from "./plistContent.vue?vue&type=template&id=2953c12c&scoped=true&"
import script from "./plistContent.vue?vue&type=script&lang=js&"
export * from "./plistContent.vue?vue&type=script&lang=js&"
import style0 from "./plistContent.vue?vue&type=style&index=0&id=2953c12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953c12c",
  null
  
)

export default component.exports